import { Currency } from '../bank-account/bank-account';
import { EmployeeGlAccountKey } from '../employee-account/employee-account';
import { EntityKey } from '../expense-receipt/expense-receipt';
import { FundMovementAttachment } from '../fund-movement/fund-movement';
import { CodedDocumentKey } from '../trip/trip';

/** Mirrors Finance.Models EmployeeAdvanceStatus. */
export enum EmployeeAdvanceStatus {
  Draft = 1,
  Posted = 2,
}

/** The part of the advance for one trip. */
export interface EmployeeAdvanceLine {
  trip: EntityKey;
  tripName: string;
  amount: number;
}

export interface EmployeeAdvanceStatusHistoryEntry {
  date: string;
  status: EmployeeAdvanceStatus;
  user: { username: string | null; firstName: string | null; lastName: string | null } | null;
  comment: string | null;
}

/** Cash Treasury hands an employee for a trip (Anticipo de viaje, #5789) — mirrors Finance.Models EmployeeAdvanceDto. */
export interface EmployeeAdvance {
  id: string;
  /** e.g. NT-EADV-2026-000001 */
  number: string;
  financialCompanyReference: string;
  employee: CodedDocumentKey;
  /** The company's functional currency. */
  currency: Currency;
  lines: EmployeeAdvanceLine[];
  amount: number;
  /** What settlements have netted (#5799). */
  appliedAmount: number;
  outstanding: number;
  advanceDate: string;
  bankAccountReference: string | null;
  bankingReference: string | null;
  transferFee: number;
  securityTax: number;
  note: string | null;
  attachments: FundMovementAttachment[];
  exchangeRate: number;
  rateToUsd: number | null;
  functionalCurrency: Currency;
  functionalAmount: number | null;
  amountUsd: number | null;
  advanceGlAccount: EmployeeGlAccountKey | null;
  bankGlAccount: EmployeeGlAccountKey | null;
  journalEntryReference: string | null;
  journalEntryNumber: string | null;
  bankTransactionReference: string | null;
  bankTransactionNumber: string | null;
  status: EmployeeAdvanceStatus;
  statusHistory: EmployeeAdvanceStatusHistoryEntry[] | null;
  createdBy: string | null;
  createdDate: string | null;
}

export interface EmployeeAdvanceLineUpdate {
  tripReference: string;
  amount: number;
}

/** What the treasurer sends for a Draft advance. */
export interface EmployeeAdvanceUpdate {
  lines: EmployeeAdvanceLineUpdate[];
  /** yyyy-MM-dd */
  advanceDate: string;
  bankAccountReference: string | null;
  bankingReference: string | null;
  transferFee: number;
  securityTax: number;
  note: string | null;
}

export interface EmployeeAdvanceSearchCommand {
  search?: string | null;
  statuses?: EmployeeAdvanceStatus[] | null;
  /** One trip's advances. */
  tripReference?: string | null;
}

export interface EmployeeAdvanceCreateCommand {
  tripReferences: string[];
}
